import '../styles/Footer.css';
import React from 'react';

const FOOTER_ROUTES = [
  { label: 'Landing', href: '/' },
  { label: 'Sign Up', href: '/sign-up' },
  { label: 'Login', href: '/login' },
  { label: 'Dashboard', href: '/dashboard' },
  { label: 'Transfer', href: '/transfer' },
  { label: 'Transfer History', href: '/transfer-history' },
  { label: 'Operations', href: '/operations' },
];

function Footer() {
  return (
    <footer className="ftr-root">
      <div className="ftr-inner">
        <div className="ftr-brand">
          <div className="ftr-mark">
            <span className="ftr-dial" aria-hidden="true" />
            <p className="ftr-wordmark">Online Banking Account</p>
          </div>
          <p className="ftr-micro">Banking, Measured</p>
        </div>

        <div className="ftr-context">
          <div className="ftr-rule-h" aria-hidden="true" />
          <p className="ftr-context-line">
            An online banking system for retail clients and bank operations staff: open an
            account, check your balance, move funds, and review transfer history — read as
            instrument readings, not marketing.
          </p>
        </div>

        <nav className="ftr-routes" aria-label="Footer">
          <p className="ftr-routes-head">Destinations</p>
          {FOOTER_ROUTES.map((route) => (
            <a key={route.href} className="ftr-route" href={route.href}>
              <span className="ftr-route-label">{route.label}</span>
              <span className="ftr-route-value">{route.href}</span>
            </a>
          ))}
        </nav>
      </div>

      <div className="ftr-base">
        <p className="ftr-base-note">
          Precision banking instrument. Dark titanium surfaces, ruled ledgers, dial-like data.
        </p>
        <span className="ftr-base-mark">Measured. Not marketed.</span>
      </div>
    </footer>
  );
}

export default Footer;